// Styles
import './Item.scss';

// Libs
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@/common/components/atoms/Button/Button';
import Picture from '@/common/components/atoms/Picture/Picture';
import Tag from '@/common/components/blocks/Tag/Tag';
import { MEDIA_TYPES, VIMEO_REGEX } from '@/common/constants';
import getVideoThumbnail from '@/common/helpers/getVideoThumbnail';
import useVideoInfo from '@/common/hooks/vimeo/useVideoInfo';

// PropTypes
import { ItemDefaultProps, ItemPropTypes } from './Item.proptypes';

const Item = ({ alt, className, index, onClick, path, tag, type }) => {
  const { t } = useTranslation();
  const [newPath, setNewPath] = useState(path);
  const [videoId, setVideoId] = useState(null);

  const { data: video } = useVideoInfo(videoId);

  const handleClick = (e) => {
    e.preventDefault();
    onClick(e);
  };

  useEffect(() => {
    if (type === MEDIA_TYPES.VIDEO) {
      if (path.match(VIMEO_REGEX)) {
        setVideoId(path.match(VIMEO_REGEX)[1]);
      }

      setNewPath(getVideoThumbnail(path, video || null));
    }
  }, [path, type, video]);

  return (
    // TODO: Clean classNames
    <div
      className={`slider-media__item${className ? ` ${className}` : ''}`}
      data-qa-id="slider-media-item"
      data-qa-index={index}
    >
      <Button
        className={`slider-media__${type}-wrapper`}
        onClick={handleClick}
        context="slider-media-button"
      >
        <Picture src={newPath} alt={alt} className="slider-media__image">
          <Tag
            className="slider-media__tag"
            label={t('ebat:entities:offers_category.title.exclusivity')}
            tag={tag}
          />
        </Picture>
      </Button>
    </div>
  );
};

Item.defaultProps = {
  ...ItemDefaultProps,
};

Item.propTypes = {
  ...ItemPropTypes,
};

export default Item;
